"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reselect_1 = require("reselect");
var Localize_1 = require("../../../gen-src/Localize");
var globalTypes_1 = require("../../../gen-src/queries/globalTypes");
var CountBarCellFormatter_1 = require("../../components/datagrid/cellFormatters/CountBarCellFormatter");
var IconCellFormatter_1 = require("../../components/datagrid/cellFormatters/IconCellFormatter");
var QualityCellFormatter_1 = require("../../components/datagrid/cellFormatters/QualityCellFormatter");
var TextCellFormatter_1 = require("../../components/datagrid/cellFormatters/TextCellFormatter");
var DataQualityIconHeaderFormatFactory_1 = require("../../components/datagrid/headerFormatters/DataQualityIconHeaderFormatFactory");
var SortableHeaderFormatter_1 = require("../../components/datagrid/headerFormatters/SortableHeaderFormatter");
var TypedDataGridInterfaces_1 = require("../../components/datagrid/TypedDataGridInterfaces");
var DatabaseIcon_1 = require("../../components/icons/DatabaseIcon");
var ExplorerStyledDisplayGrid_1 = require("../../components/sharedDisplayGrid/ExplorerStyledDisplayGrid");
var MessageUtils_1 = require("../../displayUtils/MessageUtils");
var ConnectToErrorHandling_1 = require("../ConnectToErrorHandling");
var columns = [
    function (sortParams) { return ({
        name: 'warning',
        dataKey: TypedDataGridInterfaces_1.UnsortableColumnKey,
        cellFormatter: QualityCellFormatter_1.createDataQualityCellFormatter(function (r) { return !r.dataQualityWarning ? undefined : __assign({ kind: 'fragment' }, r.dataQualityWarning); }, function (rowData) { return !rowData.isSupported; }, true, 'connect-to-dialog-data-grid-stacking-root'),
        headerText: '',
        headerFormatter: DataQualityIconHeaderFormatFactory_1.DataQualityIconHeaderFormatterFactory,
        resizable: false,
        sortable: false,
    }); },
    function (sortParams) { return ({
        name: 'isCertified',
        dataKey: TypedDataGridInterfaces_1.UnsortableColumnKey,
        cellFormatter: IconCellFormatter_1.createIconCellFormatter(function (rowData) { return React.createElement(DatabaseIcon_1.DatabaseMediumIcon, { database: __assign({}, rowData, { connectionType: rowData.connectionType || '' }) }); }, function (rowData) { return DatabaseIcon_1.getDatabaseIconTooltip(__assign({}, rowData, { connectionType: rowData.connectionType || '' })); }, function (rowData) { return !rowData.isSupported; }),
        headerText: Localize_1.Messages.GridHeaderType(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(sortParams),
        resizable: false,
        sortable: false,
    }); },
    function (sortParams) { return ({
        name: 'name',
        dataKey: globalTypes_1.DatabaseOrderField.NAME,
        cellFormatter: TextCellFormatter_1.createTextCellFormatter(function (_a) {
            var name = _a.name;
            return name;
        }, undefined, function (rowData) { return !rowData.isSupported; }),
        headerText: Localize_1.Messages.GridHeaderName(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(sortParams),
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'workbookConnectionCount',
        dataKey: globalTypes_1.DatabaseOrderField.DOWNSTREAM_WORKBOOKS_COUNT,
        cellFormatter: CountBarCellFormatter_1.createCountBarCellFormatter(function (_a) {
            var workbookConnectionCount = _a.workbookConnectionCount;
            return workbookConnectionCount;
        }, function (_a) {
            var workbookMaxCount = _a.workbookMaxCount;
            return workbookMaxCount ? workbookMaxCount : null;
        }, 'connectTo', function (rowData) { return !rowData.isSupported; }),
        headerText: Localize_1.Messages.GridHeaderConnectionCountWorkbooks(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(sortParams),
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'hostName',
        dataKey: TypedDataGridInterfaces_1.UnsortableColumnKey,
        cellFormatter: TextCellFormatter_1.createTextCellFormatter(function (_a) {
            var hostName = _a.hostName;
            return hostName;
        }, undefined, function (rowData) { return !rowData.isSupported; }),
        headerText: Localize_1.Messages.GridHeaderServerOrPath(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(sortParams),
        sortable: false,
    }); },
    function (sortParams) { return ({
        name: 'connectionType',
        dataKey: globalTypes_1.DatabaseOrderField.CONNECTION_TYPE,
        cellFormatter: TextCellFormatter_1.createTextCellFormatter(function (rowData) { return MessageUtils_1.messageForConnectionType(rowData.connectionType); }, undefined, function (rowData) { return !rowData.isSupported; }),
        headerText: Localize_1.Messages.GridHeaderConnectionType(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(sortParams),
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'contact',
        dataKey: TypedDataGridInterfaces_1.UnsortableColumnKey,
        cellFormatter: TextCellFormatter_1.createTextCellFormatter(function (_a) {
            var contact = _a.contact;
            return contact || '';
        }, undefined, function (rowData) { return !rowData.isSupported; }),
        headerText: Localize_1.Messages.GridHeaderContact(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(sortParams),
        growToFit: true,
        sortable: false,
    }); },
];
var ConnectToDatabasesDisplayGrid = /** @class */ (function (_super) {
    __extends(ConnectToDatabasesDisplayGrid, _super);
    function ConnectToDatabasesDisplayGrid() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // tslint:disable-next-line: typedef
        _this.cols = reselect_1.defaultMemoize(createColumns);
        return _this;
    }
    ConnectToDatabasesDisplayGrid.prototype.render = function () {
        return (React.createElement(ExplorerStyledDisplayGrid_1.ExplorerStyledDisplayGrid, { columns: this.cols(this.props.orderBy, this.props.updateSortOrder), emptyGridMessage: this.props.hasFilter ? Localize_1.Messages.EmptyConnectToGridWithFilter() : Localize_1.Messages.EmptyConnectToGridWithoutFilter(), rowCount: this.props.rowCount, rowStore: this.props.rowStore, selectedKeys: this.props.selectedKeys, updateSelectionForKey: this.props.updateSelectionForKey, selectionMode: ExplorerStyledDisplayGrid_1.SelectionMode.Row, renderErrors: ConnectToErrorHandling_1.reportConnectToGraphQLErrors, orderBy: this.props.orderBy, updateSortOrder: this.props.updateSortOrder }));
    };
    return ConnectToDatabasesDisplayGrid;
}(React.PureComponent));
exports.ConnectToDatabasesDisplayGrid = ConnectToDatabasesDisplayGrid;
function createColumns(orderBy, updateSortOrder) {
    var gridSortProps = { orderBy: orderBy, updateSortOrder: updateSortOrder };
    return columns.map(function (columnFactory) { return columnFactory(gridSortProps); });
}
//# sourceMappingURL=ConnectToDatabasesDisplayGrid.js.map